import DepositContainer from "@/components/shared/deposit/DepositContainer";
import { useSystemWalletDetails } from "@/hooks";
import type { Wallet } from "@/interfaces/wallet";
import { makeRequest } from "@/utils/makeRequest";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

const AdminDeposit = () => {
  const { systemType } = useParams<{ systemType: string }>();

  const {
    data: wallet,
    isLoading,
    isError,
    refetch,
  } = useSystemWalletDetails(systemType!);

  if (isLoading) {
    return <div>Loading wallet...</div>;
  }

  if (isError || !wallet) {
    return <div>Unable to load wallet.</div>;
  }

  return (
    <DepositContainer
      wallet={wallet}
      assets={wallet.assets.filter((asset) => !asset.token.isFiat)}
    />
  );
};

export default AdminDeposit;
